export class TemplateBotaoModel{
  id?: number;
  type: string | null = null;
  text: string | null = null;
  payload?: string;
  valor?: string;
  phone_number?: string;
  url?: string;
}
